import { useEffect, useRef } from "react";

interface KPIGaugeProps {
  value: number;
  label: string;
  color: string;
  maxValue?: number;
}

export function KPIGauge({
  value,
  label,
  color,
  maxValue = 100,
}: KPIGaugeProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = 65;
    const lineWidth = 12;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
    ctx.strokeStyle = "#1e293b";
    ctx.lineWidth = lineWidth;
    ctx.stroke();

    const percentage = (value / maxValue) * 100;
    const endAngle = -Math.PI / 2 + (2 * Math.PI * percentage) / 100;

    ctx.beginPath();
    ctx.arc(centerX, centerY, radius, -Math.PI / 2, endAngle);
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.lineCap = "round";
    ctx.stroke();

    ctx.fillStyle = "#ffffff";
    ctx.font = "bold 20px sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(`${value.toFixed(0)}%`, centerX, centerY);

    ctx.fillStyle = "#94a3b8";
    ctx.font = "12px sans-serif";
    ctx.fillText(label, centerX, centerY + 30);
  }, [value, label, color, maxValue]);

  return (
    <canvas ref={canvasRef} width={150} height={150} className="mx-auto" />
  );
}
